import { Box, Stack, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import React, { createContext } from "react";
import { Link } from "react-router-dom";
export const BreadcrumbContext = createContext({});

export default function Breadcrumb({ title: name, links = [] }) {
  
  return (
    <Box
      sx={{
        display: "inline-block",
        my: "3rem",
        p: "1rem",
        background: "white",
        minWidth: {
          xs: '80%',
          sm: "40%"
        },
        opacity: 0.6,
        borderRadius: "4px"
      }}
    >
      <Typography variant="h5" sx={{ fontSize: "38px" }}>
        {name}
      </Typography>
      <Stack direction="row">
        {links.map(({ url = "", title }, i) => {
          const isLast = i < links.length - 1;
          return (
            <>
              <Link style={{ textDecoration: 'none' }} to={url}>
                <Typography variant="body1" color={isLast ? "primary" : "black"}>
                  {title}
                </Typography>
              </Link>
              {isLast && <ChevronRightIcon sx={{ width: "20px" }} />}
            </>
          );
        })}
      </Stack>
    </Box>
  );
}
